import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import { delay, map, tap } from 'rxjs/operators';
import { IRebalanceResult, ResultsCount } from '@irb/irb-rebalance/results/results.model';
import {Models} from '@irb/irb-models/models-new/models.service';
import {ISecurityType} from "@irb/irb-models/irb-models.model";

@Injectable({ providedIn: 'root' })
export class RebalanceResultService {
    _filterCriteria: string= '';
    _sortCriteria: string = '';
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })  
      };

    currentResultCountDisplayed: number = null;
    currentRowIndex: number = null;

    constructor(private readonly http: HttpClient) { }

    getRebalanceResults(params: any): Observable<HttpResponse<IRebalanceResult[]>> {
        const headers = new HttpHeaders({
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
          });
        let sort = '';
        let filterKeys = '';

        if (params.request.sortModel.length > 0) {
            const sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            sort = 'sort(' + sortOrder + sortColumn + ')';
            this._sortCriteria = 'sort(' + sortOrder + sortColumn + ')';
        }

        if (params.request.filterModel && params.request.filterModel['rebalName']) {
            if (params.request.filterModel['rebalName'].filter) {
                filterKeys = filterKeys + '%26rebalName%3D' + encodeURIComponent(params.request.filterModel['rebalName'].filter);
            }
        }
        if (params.request.filterModel && params.request.filterModel['rebalPkgId']) {
            if (params.request.filterModel['rebalPkgId'].values) {
                filterKeys = filterKeys + '%26rebalPkgId%3D' + params.request.filterModel['rebalPkgId'].values;
            }
        }
        if (params.request.filterModel && params.request.filterModel['rebalTypeDesc']) {
            if (params.request.filterModel['rebalTypeDesc'].values) {
                filterKeys = filterKeys + '%26rebalTypeDesc%3D' + params.request.filterModel['rebalTypeDesc'].values;
            }
        }
        if (params.request.filterModel && params.request.filterModel['scheduleType']) {
            if (params.request.filterModel['scheduleType'].values) {
                filterKeys = filterKeys + '%26scheduleType%3D' + params.request.filterModel['scheduleType'].values;
            }
        }
        if (params.request.filterModel && params.request.filterModel['createdBy']) {
            if (params.request.filterModel['createdBy'].values) {
                filterKeys = filterKeys + '%26createdBy%3D' + params.request.filterModel['createdBy'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['containsPortfolio']) {
            if (params.request.filterModel['containsPortfolio'].filter) {
                filterKeys = filterKeys + '%26portfolioName%3D' + encodeURIComponent(params.request.filterModel['containsPortfolio'].filter);
            }
        }
        if (params.request.filterModel && params.request.filterModel['containsAccount']) {
            if (params.request.filterModel['containsAccount'].filter) {
                filterKeys = filterKeys + '%26accountNumber%3D' + encodeURIComponent(params.request.filterModel['containsAccount'].filter);
            }
        }
        if (params.request.filterModel && params.request.filterModel['completionDate']) {
            let fromDate = params.request.filterModel['completionDate'].filterFrom;
            let toDate = params.request.filterModel['completionDate'].filterTo;
            const filterFromToDateValue = '%26fromDate%3D' + fromDate + '%26toDate%3D' + toDate;
            filterKeys = filterKeys + filterFromToDateValue ;
        }

        if (params.request.filterModel && params.request.filterModel['totalApprovedPorts']) {
            const totalApprovedPorts = params.request.filterModel['totalApprovedPorts'].value;
            if (totalApprovedPorts !== -1) {
                const filterApprove = totalApprovedPorts === 'Yes' ? '%26totalApprovedPorts%3DYes' : '%26totalApprovedPorts%3DNo';
                filterKeys = filterKeys + filterApprove ;
            }
        }

        if (params.request.filterModel && params.request.filterModel['pendingResults']) {
            const pendingResults = params.request.filterModel['pendingResults'].values;
            if (pendingResults) {
                filterKeys = filterKeys + '%26pendingResults%3D' + pendingResults;
            }
        }

        if (params.request.filterModel && params.request.filterModel['masterAccount']) {
            const masterAccounts = params.request.filterModel['masterAccount'].values;
            if (masterAccounts) {
                filterKeys = filterKeys + '%26masterAccount%3D' + masterAccounts;
            }
        }

        if (filterKeys) {
            this._filterCriteria = '&Filter=' + filterKeys;
        } else {
            this._filterCriteria = '';
        }
        return this.http.post<IRebalanceResult[]>('/irebalone/rebalance/results-inventory/?' + sort,{
            Filter:filterKeys
        },
            { headers: headers, observe: 'response' })
            .pipe(delay(1000), tap(_res => {
                //console.log(res.headers.get('Filter-Count'));
            })
            );
    }
    getResultsCount(): Observable<ResultsCount> {
        return this.http.get<ResultsCount>('/irebalone/rebalance/rebalances-count').pipe(delay(1000));
    }
    clearCriteria() {
        this._filterCriteria ='';
        this._sortCriteria ='';
    }
    getComboDropDownValues( params: any): Observable<string[]> {
        return this.http.get<string[]>('/irebalone/rebalance/rebalance-inv-values/' + params ).pipe(delay(1000));
    }
    exportDetails(data: any): Observable<Blob> {
        const totalRecords = '&totalRecords=' + data;
        return this.http.post('/irebalone/rebalance/async/export-rebal-results?'+this._sortCriteria+totalRecords+this._filterCriteria,totalRecords,{ responseType: 'blob' });
    }

    getCurrentResultCountDisplayed() {
        return this.currentResultCountDisplayed;
    }

    setCurrentResultCountDisplayed(currentResultCountDisplayed: number) {
        return this.currentResultCountDisplayed = currentResultCountDisplayed;
    }

    getCurrentRowIndex() {
        return this.currentRowIndex;
    }

    setCurrentRowIndex(rowIndex: number) {
        return this.currentRowIndex = rowIndex;
    }

    getPrevnextModel(startRow: any) {
        let endRow = startRow + 1;
        const headers = new HttpHeaders({
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=' + startRow + '-' + (--endRow)
        });

        const filterKeys = this._filterCriteria === "" ? "" : this._filterCriteria.replace("&Filter=","");
        return this.http.post('/irebalone/rebalance/results-inventory/?' + this._sortCriteria,{Filter:filterKeys},{ headers: headers, observe: "response" });
    }

    getRebalancesForDelete(request: any) {
        request.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');
        request.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');
        return this.http.post('/irebalone/rebalance/get-selected-rebalance-results-by-ids', request);
    }

    exportRebalanceResults(request: any) {
        request.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');
        request.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');
        return this.http.post('/irebalone/rebalance/export-selected-rebal-results', request);
    }

    deleteRebalances(request: any) {
        return this.http.post('/irebalone/rebalance/delete-selected-rebalance-results', request);
    }

    getMasterAccountList() {
        return this.http.get('/irebalone/rebalance/master-account-drop-down').pipe(map((resp: any) => resp && resp.data ? resp.data.irebalResponse : resp.errors));
    }
}
